<div class="gauge-graph-container">
    <div *ngFor="let graph of graph.channels" class="gauge-graph">
        <app-gauge-graph
            [channel]="channels[graph.fcuChannelId]"
            [divisions]="graph.divisions"
        ></app-gauge-graph>
    </div>
</div>
